import React from 'react';
import { BrandMark, BrandWord } from '../Navbar/Navbar';
import './Footer.css';

function Footer() {
    return (
        <footer>
            <a href="/" className="footer-logo" aria-label="AIColl">
                <BrandMark className="brand-mark--sm" />
                <BrandWord light />
            </a>

            <span className="footer-copy">&copy; 2026 AIColl. Все права защищены.</span>

            <div className="footer-links">
                <a href="mailto:support@aicoll.ru">support@aicoll.ru</a>
                <a href="/app.html">Войти в приложение</a>
            </div>
        </footer>
    );
}

export default Footer;
